exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vcp-container{position:relative;margin:0 auto}.vcp-container,.vcp-container video{width:100%;height:100%;background-color:#000}", ""]);

// exports
